// EmailEditorWithFields.tsx
import React, { useCallback, useRef, useState, useEffect } from "react";
import ReactQuill, { Quill } from "react-quill-new";
import { useDrop } from "react-dnd";

interface EmailEditorProps {
    value: string;
    typeToAccept: string;
    onChangeHtml: (html: string) => void;
}

export const QuillTextEditor: React.FC<EmailEditorProps> = ({value, onChangeHtml, typeToAccept}) => {
    const quillRef = useRef<ReactQuill>(null);

    const [, dropRef] = useDrop(
        () => ({
            accept: typeToAccept,
            drop: (item: { fieldName: string }) => {
                if (!quillRef.current) return;
                const quillEditor = quillRef.current.getEditor();

                const range = quillEditor.getSelection(true);
                const index = range ? range.index : quillEditor.getLength();

                quillEditor.insertText(index, '{{' + item.fieldName + '}}', 'user');
                quillEditor.setSelection(index + item.fieldName.length + 4, 0);
            },
        }),
        []
    );

    const handleChange = useCallback((html: string) => {
        onChangeHtml(html);
    }, [onChangeHtml]);

    return (
        <div
            ref={el => {
                dropRef(el)
            }}
        >
            <ReactQuill
                ref={quillRef}
                theme="snow"
                value={value}
                onChange={handleChange}
                modules={{
                    toolbar: [
                        [{ header: [1, 2, false] }],
                        ["bold", "italic", "underline"],
                        [{ list: "ordered" }, { list: "bullet" }],
                    ],
                }}
                formats={[
                    "header",
                    "bold",
                    "italic",
                    "underline",
                    "list",
                    "bullet",
                    "link",
                ]}
                placeholder="Type your message here…"
                className="email-editor"
            />
        </div>
    );
};
